if (typeof loadeMoreSlider_G === 'undefined') {
	globalThis.loadeMoreSlider_G = null;
}

(function () {
	// A card can be resized after its slider was set up: the per-row switch
	// changes the grid density, and the new width is animated. Swiper keeps the
	// slide width it measured at init, so the neighbouring media starts showing
	// through at the edge of the card. Re-measure on every size change instead.
	const cardResizeObserver =
		typeof ResizeObserver === "undefined"
			? null
			: new ResizeObserver((entries) => {
					entries.forEach((entry) => entry.target.swiper?.update());
				});

	const observeSliders = () => {
		document
			.querySelectorAll(".product-card-js")
			.forEach((slider) => cardResizeObserver?.observe(slider));
	};

	// SUROWA perf: slider karty startuje, gdy karta jest 300 px od ekranu, a nie wszystkie od razu
	// (kolekcja na telefonie: 24 karty, ok. 430 ms pracy procesora przy starcie). Przed startem karta
	// wygląda tak samo - slajdy już leżą w rzędzie dzięki CSS Swipera.
	const sliderObserver =
		typeof IntersectionObserver === "undefined"
			? null
			: new IntersectionObserver(
					(entries) => {
						entries.forEach((entry) => {
							if (!entry.isIntersecting) return;
							sliderObserver.unobserve(entry.target);
							createSlider(entry.target);
						});
					},
					{ rootMargin: "300px 0px" }
				);

	const initSlider = () => {
		document.querySelectorAll(".product-card-js").forEach((slider) => {
			if (sliderObserver) sliderObserver.observe(slider);
			else createSlider(slider);
		});
	};

	const createSlider = (slider) => {
		// Karta po "Pokaż więcej" jest obserwowana ponownie - nie zakładaj jej drugiego Swipera.
		if (slider.swiper) return;
		const dir = document.querySelector('html').getAttribute("dir");

		let nextEl = ".product-button-group .swiper-button-next";
		let prevEl = ".product-button-group .swiper-button-prev";
		if (dir === 'rtl') {
			[nextEl, prevEl] = [prevEl, nextEl];
		}
		{
			const productSlider = new Swiper(slider, {
				// 'auto' makes Swiper measure the real, fractional slide width. With a
				// numeric slidesPerView it steps by the rounded clientWidth instead, and
				// the difference adds up slide by slide until the neighbouring media
				// shows through at the edge of the card.
				slidesPerView: 'auto',
				pagination: {
					el: ".product-pagination .swiper-pagination",
					clickable: true,
				},
				scrollbar: {
					el: '.swiper-scrollbar',
					draggable: false,  // true jeśli chcesz też przeciągać
					dragSize: 60,      // KLUCZ: stała szerokość kreski w px zamiast 'auto'
				},
				navigation: {
					nextEl: nextEl,
					prevEl: prevEl,
				},
				allowTouchMove: true,
				990: {
					allowTouchMove: false,
				},
			});
		}
	};

	initSlider();
	observeSliders();
	loadeMoreSlider_G = initSlider;

	// Sliders rebuilt elsewhere (facets, product recommendations) need watching too.
	window.addEventListener("columnsChanged", observeSliders);

	document.addEventListener("shopify:section:load", function () {
		initSlider();
		observeSliders();
	});
})();
